import {Maybe, SlideType} from '../../../../../../graphql/generated/types';

export function checkWebAccessible({
  isMobile,
  slideType,
  isTextViewer,
}: {
  isMobile: boolean;
  slideType: Maybe<SlideType>;
  isTextViewer: Maybe<boolean>;
}): boolean {
  if (!slideType) {
    return false;
  }
  return !!SLIDE_TYPE_VO_ACCESSIBLE_MAP[slideType](isMobile, isTextViewer);
}

const SLIDE_TYPE_VO_ACCESSIBLE_MAP: {
  [key in SlideType]: (
    isMobile: boolean,
    isTextViewer: Maybe<boolean>
  ) => boolean;
} = {
  [SlideType.Vod]: () => false,
  [SlideType.Slide]: () => false,
  [SlideType.AudioBook]: () => false,
  [SlideType.None]: () => false,
  // NEXT 부터는 텍스트뷰어 지원함(웹Epub = 텍스트뷰어)
  [SlideType.Epub]: (isMobile, isTextViewer) => (isTextViewer ? true : false),
  [SlideType.VideoOnly]: () => false,
  [SlideType.Comic]: () => true,
  [SlideType.TalkHumor]: () => true,
  [SlideType.TalkNovel]: isMobile => (isMobile ? true : false),
};
